import { useGetCategoriesMapQuery } from '../api/core'

export const useGetCategoriesArray = (marketIso: string) => {
  // converts the map of categories to an array
  const { data: categories } = useGetCategoriesMapQuery({ marketIso })
  return { categories: categories ? Object.values(categories) : undefined, isLoading: !categories }
}
